import { useT } from '@repo/ui/hooks'

export function HomeRoute() {
  const { tc, t } = useT({ keyPrefix: 'admin' })

  return (
    <div className="z-10 flex h-full flex-1 items-center justify-center">
      <div className="flex flex-col items-start justify-center gap-4">
        <div className="flex select-none flex-col items-center justify-center px-24 text-center">
          <p className="text-primary-600 mb-4 text-5xl font-bold">{tc('admin', { cfl: true })}</p>
          <p className="text-primary-400 text-2xl">{t('youCanTuneSettings')}</p>
        </div>
      </div>
    </div>
  )
}
